export type Bonus = {
  number: number;
  title: string;
  value: number;
  image: string;
  description: string;
  flow?: string[];
  listLabel?: string;
  list?: string[];
  closing: string[];
};

export const bonuses: Bonus[] = [
  {
    number: 1,
    title: "30 Educational Mastopexy Cases",
    value: 47,
    image: "https://cdn.magicpatterns.com/patterns/generated-images/89fe32a3-2bb7-47aa-8e2c-63bc42743d46.jpg",
    description:
      "A library of additional educational case exercises designed to help you repeatedly practice the Mastopexy Blueprint framework.",
    flow: ["Case", "Analyze", "Plan", "Review", "Learn"],
    closing: ["The more cases you review, the more familiar the framework becomes."],
  },
  {
    number: 2,
    title: "The 10-Minute Mastopexy Review™",
    value: 37,
    image: "https://cdn.magicpatterns.com/patterns/generated-images/c5fd6d5f-7d6d-47e7-9334-6199337b4d3a.jpg",
    description:
      "A condensed version of the Blueprint designed for faster educational case review. When you don't have time to work through the complete framework, use the 10-Minute Review:",
    flow: ["Case", "Variables", "Priorities", "Questions", "Review", "Lesson"],
    closing: ["One case. Ten minutes. One structured review."],
  },
  {
    number: 3,
    title: "The Mastopexy Error Review Atlas",
    value: 47,
    image: "https://cdn.magicpatterns.com/patterns/generated-images/dc9548de-e470-4e2f-b760-3f8759f75e7a.jpg",
    description: "Educational scenarios focused on common planning and case-review challenges.",
    listLabel: "For each scenario:",
    list: [
      "What happened?",
      "What may have been overlooked?",
      "Which variables deserve review?",
      "What questions should be asked?",
      "What could be documented?",
      "What is the educational lesson?",
    ],
    closing: ["Don't simply memorize complications. Train yourself to recognize what deserves attention."],
  },
  {
    number: 4,
    title: "The Surgeon's Mastopexy Review Cards",
    value: 37,
    image: "https://cdn.magicpatterns.com/patterns/generated-images/9e4def7a-4ebb-45e2-adb8-f418a7bc43b9.jpg",
    description:
      "Printable educational prompts designed for individual study, peer discussion or case conferences.",
    listLabel: "Examples:",
    list: [
      "“What are the three most important variables in this case?”",
      "“What would you review before planning the procedure?”",
      "“What asymmetries deserve attention?”",
      "“What questions remain unanswered?”",
    ],
    closing: ["One card. One question. One focused review."],
  },
  {
    number: 5,
    title: "The 30-Day Mastopexy Case Review Challenge™",
    value: 29,
    image: "https://cdn.magicpatterns.com/patterns/generated-images/f4e12c12-a8cb-4193-85e3-15cd8b3327ff.jpg",
    description:
      "A 30-day professional learning calendar designed to help you turn case review into a consistent educational habit.",
    flow: ["One case", "One exercise", "One reflection", "One lesson"],
    closing: ["Every day, one step closer to a disciplined review habit."],
  },
];
